import React from "react";
import { ErrorBoundary } from "components/Shared";
import Actor from "components/Activities/Actor";
import Context from "components/Activities/Context";
import ItemObject from "components/Activities/ItemObject";

const RejectTask = ({ activity }: { activity: tcpinpoint.ActivityItem }) => (
  <ErrorBoundary>
    <Actor actor={activity.attributes.item.actor} /> requested resubmission for{" "}
    <ItemObject object={activity.attributes.item.object} />{" "}
    <Context context={activity.attributes.item.context} />
  </ErrorBoundary>
);

export default RejectTask;
